import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VCard,{attrs:{"id":"recap-title"}},[_c(VCardTitle,{staticClass:"headline grey lighten-2"},[_vm._v(_vm._s(_vm.$t('transactionRecap.orderRefTitle')))]),_c(VCardText,{staticClass:"blue white--text text-center font-weight-thin display-4 pa-12"},[_c('pre',[_vm._v(_vm._s(_vm._f("uppercase")(_vm.$route.params.projectReference)))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }